import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-iade-kosullari',
  templateUrl: './iade-kosullari.page.html',
  styleUrls: ['./iade-kosullari.page.scss'],
})
export class IadeKosullariPage implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() {
  }

  dismiss() {
    this.modalController.dismiss();
  }
}
